import { NgModule } from '@angular/core';
import { AuroraBackgroundComponent } from './aurora-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        AuroraBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        AuroraBackgroundComponent
    ]
})
export class NcAuroraBackgroundModule { }